import { render, staticRenderFns } from "./DetailContactsPerPortal.vue?vue&type=template&id=1e4356f4&"
import script from "./DetailContactsPerPortal.vue?vue&type=script&lang=js&"
export * from "./DetailContactsPerPortal.vue?vue&type=script&lang=js&"
import style0 from "./DetailContactsPerPortal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailContactsPerPortal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports